module.exports = __webpack_public_path__ + "img/phone.563ae955.svg";